import { Ban } from "lucide-react";
import { buildBlockedDiagnosis } from "@/lib/blockedDiagnosis";

// Diagnostic card shown on blocked runs and blocked (never-executed) batch
// items. Mirrors the bug-report card's layout so a blocked result reads the
// same way a failed result does, but explains why nothing ran instead of
// describing a product defect. All wording is derived from the real stored
// reason via lib/blockedDiagnosis — nothing is hardcoded per project.
export default function BlockedDiagnosis({ reason, affected, missingEvidence = false }) {
  const diag = buildBlockedDiagnosis(reason);
  const shownAffected = affected !== undefined && affected !== null ? affected : diag.affected;
  return (
    <div className="rounded-2xl border border-violet-200 bg-violet-50/60 p-4 dark:border-violet-500/20 dark:bg-violet-500/10">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-800 dark:text-white">
        <Ban size={15} className="text-violet-500" /> Blocked diagnosis
      </p>
      <dl className="mt-2.5 space-y-2 text-xs">
        <div>
          <dt className="font-semibold text-violet-700 dark:text-violet-300">Why this test was blocked</dt>
          <dd className="mt-0.5 text-slate-700 dark:text-slate-200">{diag.why}</dd>
        </div>
        <div>
          <dt className="font-semibold text-violet-700 dark:text-violet-300">Blocking reason</dt>
          <dd className="mt-0.5 whitespace-pre-line break-words text-slate-700 dark:text-slate-200">
            {diag.reason || "Blocking reason was not recorded for this execution."}
          </dd>
        </div>
        <div>
          <dt className="font-semibold text-violet-700 dark:text-violet-300">What was affected</dt>
          <dd className="mt-0.5 text-slate-700 dark:text-slate-200">{shownAffected}</dd>
        </div>
        <div>
          <dt className="font-semibold text-violet-700 dark:text-violet-300">Recommended action</dt>
          <dd className="mt-0.5 text-slate-700 dark:text-slate-200">{diag.action}</dd>
        </div>
      </dl>
      {missingEvidence && (
        <p className="mt-3 text-xs italic text-slate-500 dark:text-slate-400">
          No execution evidence was captured because the test was blocked before execution.
        </p>
      )}
    </div>
  );
}